<script setup lang="ts">
    import { AccordionContent, NavigationMenuContent } from 'radix-vue'
    import { injectSiteNavRootContext } from './site-nav-root.vue'

    const root = injectSiteNavRootContext()!
</script>
<template>
    <AccordionContent v-if="root.type.value === 'accordion'">
        <slot />
    </AccordionContent>
    <NavigationMenuContent v-else>
        <slot />
    </NavigationMenuContent>
</template>